import React from 'react';
import FloatingMenuOption from './FloatingMenuOption';
import {useRoomPreview} from 'components/customer/RoomPlanner/components/helpers/RoomPreview';
import {useRoomPlannerContext} from 'components/customer/RoomPlanner/components/RoomPlannerContext';
import {
    hasDoors,
    CabinetGroup,
} from 'components/customer/RoomPlanner/helpers/doorDetection';

const FloatingMenu = () => {
    const isRoomPreview = useRoomPreview();
    const {selectedCabinetGroup} = useRoomPlannerContext();
    const cabinetHasDoors = selectedCabinetGroup
        ? hasDoors(selectedCabinetGroup as CabinetGroup)
        : false;

    if (isRoomPreview) {
        if (!cabinetHasDoors) {
            return null;
        }

        return <FloatingMenuOption.DoorToggle />;
    }

    return (
        <>
            <FloatingMenuOption.Edit />
            <FloatingMenuOption.Copy />
            <FloatingMenuOption.DoorToggle />
            <FloatingMenuOption.RotateRight />
            <FloatingMenuOption.Movement />
            <FloatingMenuOption.Delete />
        </>
    );
};

export default FloatingMenu;
